module.exports = __webpack_public_path__ + "static/media/scoliaLogo.c32648cb.png";